import { PlanningSearchParamUpdate } from './resolve-planning-search-param.types';

export const resolvePlanningSearchParam = (
  debouncedSearchInput: string
): PlanningSearchParamUpdate => {
  const trimmed = debouncedSearchInput.trim();

  if (trimmed.length === 0) {
    return { shouldUpdate: true, search: undefined };
  }

  if (trimmed.length >= 3) {
    return { shouldUpdate: true, search: trimmed };
  }

  return { shouldUpdate: false };
};
